export const checkIfCityLimitModeEnabled = (mode: string): boolean => /yes_city/i.test(mode);
